import { either } from 'fp-ts';
import cogoToast from 'components/ToastMessage/ToastMessage';
import { types as t, destroy } from 'mobx-state-tree';
import { errorToReactLeft, pipe } from 'utils/fp';
import { withRunInAction } from 'utils/withRunInAction';
import { safelyRemoveFromParentIfUsedInListable } from 'modules/Listings/store/helpers';
import { deleteDatasetsTE } from 'api/datasets/deleteDatasets';

export const savedFilterMSTTypeOnly = t
  .model({
    id: t.string,
    created_at: t.string,
    modified_at: t.string,
    application_id: t.union(t.optional(t.string, ''), t.undefined),
    name: t.string,
    algorithm: t.string,
    visibility: t.model({
      gettable: t.number,
    }),
    query: t.frozen(),
  })
  .named('CFSavedSearchMSTType');

export const defaultFilterMSTTypeOnly = t
  .model({
    id: t.string,
    created_at: t.string,
    modified_at: t.string,
    user_id: t.string,
    app_id: t.string,
    dataset_id: t.string,
    saved_search: savedFilterMSTTypeOnly,
  })
  .named('CFDefaultFilterMSTType');

export const datasetMSTTypeOnly = t
  .model({
    id: t.string,
    created_at: t.string,
    modified_at: t.string,
    user_id: t.string,
    app_id: t.string,
    description: t.union(t.optional(t.string, ''), t.undefined),
    notes: t.union(t.optional(t.string, ''), t.undefined),
    metadata: t.frozen(),
    visibility: t.model({
      gettable: t.number,
    }),
    default_filter: t.frozen(), // defaultFilterMSTTypeOnly,
    image: t.maybe(
      t.model({
        url: t.optional(t.string, ''),
        base64: t.maybe(t.string),
        hosted: t.maybe(
          t.model({
            crossorigin: t.maybe(t.string),
            sizes: t.optional(t.array(t.string), []),
            prefix: t.optional(t.string, ''),
            suffix: t.optional(t.string, ''),
          }),
        ),
      }),
    ),
    version: t.frozen(),
  })
  .named('CFDatasetMSTType');

export const datasetMST = t.compose(withRunInAction(), datasetMSTTypeOnly).actions((self) => ({
  delete: async ({ closeDeleteModal }: { closeDeleteModal: () => void }) => {
    // call the api
    const api = await deleteDatasetsTE({ userId: self.user_id, appId: self.app_id, datasetIds: [self.id] }, errorToReactLeft)();
    pipe(
      api,
      either.fold(
        ({ props }) => {
          cogoToast.error(props?.reason || 'Could not delete the Dataset', { heading: props?.title || 'Error' });
          closeDeleteModal();
        },
        () => {
          cogoToast.success(`Dataset ${self.id} deleted!`);
          self.runInAction(() => {
            safelyRemoveFromParentIfUsedInListable(self as typeof self & { delete: () => Promise<void> });
            destroy(self);
          });
          closeDeleteModal();
        },
      ),
    );
  },
}));
